import { apiComprehensiveAssessmentServiceManagementForms, TAssessmentForm } from '@/api/ComprehensiveAssessmentServiceManagement/ComprehensiveAssessmentServiceManagementForms';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class CareAssessmentFormService {
    /** 所有表單 */
    private readonly assessmentForms = new BehaviorSubject<TAssessmentForm[]>([]);
    readonly assessmentForms$ = this.assessmentForms.asObservable();

    constructor() {
        if (this.assessmentForms.value.length === 0) {
            void this.fetchAssessmentForms();
        }
    }

    private async fetchAssessmentForms() {
        await apiComprehensiveAssessmentServiceManagementForms()
            .then((response) => {
                this.setAssessmentForms(response.data.data);
            });
        return this.assessmentForms.value;
    }

    private setAssessmentForms(forms: TAssessmentForm[]) {
        this.assessmentForms.next(forms);
    }

    async getAssessmentForms() {
        return await this.fetchAssessmentForms();
    }
}
